import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { trackEvent } from "../../utils/analytics";
import ForminputText from '../forminput/forminput_text.js';
/* import ForminputTextbox from '../forminput/forminput_textbox.js';
import ForminputDropdown from '../forminput/forminput_dropdown.js'; */
import StripePayment from './stripe_payment.js';
import { ReactComponent as IconClose } from '../../media/icons/close.svg';
import { format_price } from '../../functions/functions_formatting.js';


export default class Purchase extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Default states
            cc_name: null
        };

        this.setFormValue = this.setFormValue.bind(this);
        this.handlePurchase = this.handlePurchase.bind(this);
    }


    componentDidMount() {
        // Track event
        trackEvent("trip_purchase_click", { trip_id: this.props.trip_id, user_id_action: this.props.user_id });
    }


    setFormValue(label, value) {
        this.setState({
            [label]: value
        });
    }


    async handlePurchase() {
        try {
            await this.props.setLoading("purchase_handlePurchase");
            if (true) {
                await this.props.handlePurchase();
            } else {
                this.props.setError("Error", "Payment data is insufficient - please provide all required information.");
            }
        } catch (error) {
            // Track error
            var name = "Payment error";
            var message = "Could complete payment. Please try again. In case you continue to experience issues, please contact support (support@guidr.net).";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Purchase_handlePurchase");
        } finally {
            await this.props.unsetLoading("purchase_handlePurchase");
        }
    }


    render() {
        return (
            <div className="trip__popup-container">
                <div className="trip__popup">
                    <div className="trip__popup__close-wrapper">
                        <IconClose onClick={this.props.unsetPopup} className="trip__popup__close" />
                    </div>

                    <div className="trip__popup__section trip__popup__section--no-top-margin">
                        <div className="trip__popup__element trip__popup__title text-subtitle">
                            Order overview
                        </div>

                        <div className="trip__popup__element trip__popup__ordertable">
                            {this.props.items.map((item, index) => (
                                <>
                                    <div key={index + "_label"} className="trip__popup__ordertable__itemlabel">
                                        <div className="">
                                            {item.label || "Trip itinerary"}: {item.label}
                                        </div>
                                        <div className="text-small text-color-grey">
                                            {"By @" + this.props.owner_name}
                                        </div>
                                    </div>
                                    <div key={index + "_price"} className="trip__popup__ordertable__price">
                                        {format_price(parseInt(item.amount))}
                                    </div>
                                </>
                            ))}


                            <div className="trip__popup__ordertable__itemlabel">
                                Subtotal
                            </div>
                            <div className="trip__popup__ordertable__price">
                                {format_price(parseInt(this.props.amount))}
                            </div>

                            <div className="trip__popup__ordertable__itemlabel">
                                Taxes
                            </div>
                            <div className="trip__popup__ordertable__price">
                                {format_price(0)}
                            </div>

                            <div className="trip__popup__ordertable__itemlabel text-bold">
                                Total
                            </div>
                            <div className="trip__popup__ordertable__price text-bold">
                                {format_price(parseInt(this.props.amount))}
                            </div>
                        </div>
                    </div>


                    <div className="trip__popup__section">
                        <div className="trip__popup__element trip__popup__title text-subtitle">
                            Payment details
                        </div>

                        <div className="trip__popup__element">
                            <div className="trip__popup__element__content">
                                <ForminputText
                                    name={"cc_name"}
                                    label={"Name on card"}
                                    default_value={this.state.cc_name}
                                    setFormValue={this.setFormValue}
                                    required={true}
                                />
                            </div>
                        </div>

                        <StripePayment
                            handlePurchase={this.handlePurchase}
                            setError={this.props.setError}
                            logEvent={this.props.logEvent}
                            setLoading={this.props.setLoading}
                            unsetLoading={this.props.unsetLoading}
                            baseUrl={this.props.baseUrl}
                            apiTimeout={this.props.apiTimeout}
                            trip_id={this.props.trip_id}
                            trip_title={this.props.trip_title}
                            user_id={this.props.user_id}
                            owner_name={this.props.owner_name}
                            owner_id={this.props.owner_id}
                            amount={parseInt(this.props.amount)}
                            items={this.props.items}
                        />

                        <div className="trip__popup__element">
                            <div className="trip__popup__element__content">
                                <div className="text-small text-color-grey">
                                    By proceeding, you agree to our <Link to="/terms" className="text-color-dark">Terms of Service</Link> and <Link to="/privacy" className="text-color-dark">Privacy Policy</Link>.
                                </div>
                            </div>
                            <div className="trip__popup__element__content">
                                <div className="text-small text-color-grey">
                                    Need help? Email us at <Link to="mailto:support@guidr.net" className="text-color-dark">support@guidr.net</Link>.
                                </div>
                            </div>
                            {/* <div className="trip__popup__element__content">
                                <div className="text-small text-color-grey">
                                    Secure payments powered by Stripe.
                                </div>
                            </div> */}
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}
